module.exports = __webpack_public_path__ + "img/icon5.20f9aae3.png";